type SvgIconProps = {
  className?: string
}

const iconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true as const,
}

export const IconColumns = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M9 3v18" />
    <path d="M15 3v18" />
  </svg>
)

export const IconChevronDown = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="m6 9 6 6 6-6" />
  </svg>
)

export const IconChevronLeft = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="m15 18-6-6 6-6" />
  </svg>
)

export const IconChevronRight = ({ className }: SvgIconProps) => (
  <svg className={className} {...iconProps}>
    <path d="m9 18 6-6-6-6" />
  </svg>
)
